<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns :fields="fields" class="customize" />
          </div>
          <div style="overflow: auto">
            <b-table
              id="user-clocking-manual-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{ afterResize: columnsWidthChanged }"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(cnp)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(surname)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(shop_name)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(worked_hours)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(worked_days)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(usernames)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(reason)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:cell(reason)="data">{{
                $t(data.value)
              }}</template>

              <template v-slot:cell(shop_name)="data">
                <router-link :to="`/shops/${data.item.eshop_id}`">{{
                  data.value
                }}</router-link>
              </template>

              <template v-slot:cell(usernames)="data">
                <span v-for="(item, index) in data.value" :key="index">
                  <router-link :to="`/users/${item.to}`">{{
                    item.name
                  }}</router-link>
                </span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit(
                      'bv::refresh::table',
                      'user-clocking-manual-table'
                    )
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-record" hide-footer centered>
      <template slot="modal-title">{{ $t("Add Record") }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block" style="position: relative">
        <b-form @submit.prevent="onAddRecord" autocomplete="off" ref="record">
          <div class="mb-2 position-relative">
            <div class="multiselect-lbl">
              {{ $t("Shop") }}
            </div>
            <multiselect
              v-model="shopObject"
              :options="shopList"
              placeholder="Select shop"
              track-by="eid"
              label="name"
              :multiple="false"
              :translate="false"
            ></multiselect>
          </div>
          <FloatingLabel
            v-model="details.cnp"
            label="CNP"
            :state="isCNPValid"
            size="sm"
            aria-describedby="input-live-feedback2"
          >
            <template v-slot:feedback>
              <div id="input-live-feedback2" class="invalid-feedback">
                {{ $t("Invalid CNP") }}
              </div>
            </template>
          </FloatingLabel>
          <FloatingLabel v-model="details.name" label="Name" size="sm" />
          <FloatingLabel v-model="details.surname" label="Surname" size="sm" />

          <b-form-group :label="$t('Reason')">
            <b-form-radio
              v-model="details.reason"
              name="reason_input"
              value="Training"
            >
              {{ $t("Training") }}
            </b-form-radio>
            <b-form-radio
              v-model="details.reason"
              name="reason_input"
              value="Marketing"
            >
              {{ $t("Marketing") }}
            </b-form-radio>
            <b-form-radio
              v-model="details.reason"
              name="reason_input"
              value="Cleaning"
            >
              {{ $t("Cleaning") }}
            </b-form-radio>
          </b-form-group>

          <div class="flex">
            <VueClockPicker
              v-model="details.starting_at"
              active-color="#3a3e42"
              input-container-class="clock-picker first"
              input-class="form-control"
              placeholder="From"
              close-on-overlay
            />
            <VueClockPicker
              v-model="details.ending_at"
              active-color="#3a3e42"
              input-container-class="clock-picker second"
              input-class="form-control"
              placeholder="To"
              close-on-overlay
            />
          </div>

          <div style="text-align: right">
            <b-button
              type="submit"
              variant="success"
              :disabled="
                !(
                  isCNPValid &&
                  details.starting_at &&
                  details.ending_at &&
                  shopObject
                )
              "
              >{{ $t("Save") }}</b-button
            >
          </div>
        </b-form>
      </div>
    </b-modal>
    <b-modal id="bv-modal-userinfo" hide-footer centered size="xl">
      <template slot="modal-title">{{
        $t("User Activities (Manual)")
      }}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block" style="position: relative" v-if="params.ready">
        <UserActivityManual
          :cnp="params.cnp"
          :dateField="params.dateField"
          :dateStart="params.dateStart"
          :dateEnd="params.dateEnd"
          :shopId="params.shopId"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { successConf, errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";
import FloatingLabel from "@/components/FloatingLabel";
import validCNP from "@/shared/cnp";
import Multiselect from "@/components/multiselect-filters";
import VueClockPicker from "@/components/clock-picker";
import UserActivityManual from "./UserActivityManual";

export default {
  name: "user-clocking-manual",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    FloatingLabel,
    Multiselect,
    VueClockPicker,
    UserActivityManual,
  },
  data: function () {
    return {
      tableName: "user-clocking-manual",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: false,
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter((item) => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter((item) => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map((elem) => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map((elem) => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map((elem) => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                (elem) => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter((item) => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter((item) => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          },
        },
        {
          field: "report_time",
          type: "date",
          opens: "right",
          showDropdowns: true,
          selected: {
            startDate: moment(),
            endDate: moment(),
          },
          default: {
            startDate: moment(),
            endDate: moment(),
          },
          singleDatePicker: true,
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documenations for details
            showWeekNumbers: true, //show week numbers on each row of the calendar
          },
          ranges: false,
        },
      ],

      details: {
        cnp: "",
        name: "",
        surname: "",
        eshop_id: "",
        starting_at: "",
        ending_at: "",
      },

      params: {
        cnp: "",
        dateField: "",
        dateStart: "",
        dateEnd: "",
        shopId: "",
        ready: false,
      },

      isCNPValid: false,
      shopObject: null,

      isBusy: false,
      sortBy: "shop_id",
      sortDesc: true,
      // ua.user_id, u.cnp, u.name, u.surname, ua.shop_id, s.name, ua.day, ua.td
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      copy: null,
      filter: null,
      filterField: null,
      addLabel: "Add Record",
    };
  },
  watch: {
    "details.cnp": function (newVal) {
      this.isCNPValid = false;
      if (validCNP(newVal)) {
        this.isCNPValid = true;
      }
    },
  },
  computed: {
    fields() {
      const columns = [
        {
          key: "cnp",
          label: "CNP",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "surname",
          label: "Surname",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          class: "",
          ignore: true,
        },
      ];

      for (let i = 1; i <= 31; i++) {
        columns.push({
          key: `day_${i}`,
          label: `${i}`,
          sortable: false,
          class: "",
          ignore: true,
        });
      }

      columns.push({
        key: `worked_hours`,
        label: `Worked Hours`,
        sortable: false,
        class: "",
        ignore: true,
      });
      columns.push({
        key: `worked_days`,
        label: `Worked Days`,
        sortable: false,
        class: "",
        ignore: true,
      });
      columns.push({
        key: "usernames",
        label: "Added By",
        sortable: false,
        class: "",
        ignore: true,
      });
      columns.push({
        key: "reason",
        label: "Reason",
        sortable: false,
        class: "",
        ignore: true,
      });
      return columns;
    },

    shopList() {
      return this.$store.getters["cache/shops"];
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "bv-modal-record") {
        this.details.cnp = "";
        this.details.name = "";
        this.details.surname = "";
        this.details.eshop_id = "";
        this.details.starting_at = "";
        this.details.ending_at = "";
        this.isCNPValid = false;
        this.shopObject = null;
      } else if (modalId == "bv-modal-userinfo") {
        this.params.cnp = "";
        this.params.dateField = "";
        this.params.dateStart = "";
        this.params.dateEnd = "";
        this.params.shopId = "";
        this.params.ready = false;
        this.refresh();
      }
    });
  },
  destroyed() {
    this.$root.$off("bv::modal::hide");
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "user-clocking-manual-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.processDate(
              item.selected.startDate
            );
            paginationData.dateEnd = this.processDate(item.selected.endDate);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const userByUsername = this.$store.getters["cache/userByUsername"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
        this.$store.dispatch("cache/fetch", "users").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("userClockingManual/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.days) {
                let total_hours = 0;
                let total_days = 0;

                for (let i = 1; i <= 31; i++) {
                  if (typeof item.days[i - 1] !== "undefined") {
                    if (item.days[i - 1] !== 0) {
                      total_days += 1;
                      total_hours += item.days[i - 1];
                    }
                    item[`day_${i}`] = this.minutesToHM(item.days[i - 1]);
                  } else {
                    item[`day_${i}`] = "0";
                  }
                }

                item.worked_hours = this.minutesToHM(total_hours);
                item.worked_days = total_days;
              }

              if (item.usernames) {
                const usernames = item.usernames.split(",");
                const exists = {};
                const res = [];
                usernames.forEach((username) => {
                  let un = username.trim();

                  if (un && typeof exists[un] === "undefined") {
                    let item = null;

                    const data = userByUsername(un);
                    if (data) {
                      item = {
                        to: data.eid,
                        name: data.username,
                      };
                    } else {
                      item = {
                        to: null,
                        name: un,
                      };
                    }

                    res.push(item);
                    exists[un] = true;
                  }
                });
                item.usernames = res;
              }
            });
            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      console.log("rowClicked", item);
      this.params.cnp = item.cnp;
      this.params.dateField = "starting_at";
      this.params.dateStart = this.processDate(
        this.filterOptions[4].selected.startDate
      );
      this.params.dateEnd = this.processDate(
        this.filterOptions[4].selected.endDate
      );
      this.params.shopId = item.eshop_id;
      this.params.ready = true;
      this.$bvModal.show("bv-modal-userinfo");
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    processDate(dt) {
      let fdt = null;
      if (typeof dt.format !== "undefined") {
        fdt = dt.format().split("T")[0];
      } else {
        fdt = this.toDate(dt);
      }
      return `${fdt}T00:00:00.000Z`;
    },
    toDate(st) {
      let date_ob;
      if (st) {
        date_ob = new Date(st);
      } else {
        date_ob = new Date();
      }

      let days = ("0" + date_ob.getDate()).slice(-2);
      let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
      let year = date_ob.getFullYear();

      return `${year}-${month}-${days}`;
    },
    minutesToHM(value) {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      let ret = "";
      if (hours > 0) {
        ret += `${hours}h `;
      }
      if (minutes > 0) {
        ret += `${minutes}m`;
      }
      return ret === "" ? "0" : ret;
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {
      this.$bvModal.show("bv-modal-record");
    },
    hoursToMinutes(total) {
      if (!total) return 0;
      const parts = total.split(":", 2);
      const hours = parseInt(parts[0]) * 60;
      const minutes = parseInt(parts[1]);
      return hours + minutes;
    },
    onAddRecord() {
      const loader = this.$loading.open({
        container: this.$refs.record,
      });

      const apiAction = "userActivityManual/create";

      const detailsData = {};
      detailsData.cnp = this.details.cnp;
      detailsData.name = this.details.name;
      detailsData.surname = this.details.surname;
      detailsData.reason = this.details.reason;

      const starting_at = this.hoursToMinutes(this.details.starting_at);
      const ending_at = this.hoursToMinutes(this.details.ending_at);

      detailsData.starting_at =
        starting_at < ending_at ? starting_at : ending_at;
      detailsData.ending_at = starting_at < ending_at ? ending_at : starting_at;
      detailsData.eshop_id = this.shopObject ? this.shopObject.eid : null;

      this.$store
        .dispatch(apiAction, detailsData)
        .then((resp) => {
          console.log(resp);
          if (resp.data.id) {
            const msg = "Record created";
            this.showSuccessNotification(msg);
            this.$root.$emit(
              "bv::refresh::table",
              "user-clocking-manual-table"
            );
            this.$bvModal.hide("bv-modal-record");
          }
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
}
::v-deep .flex > .clock-picker {
  max-width: 75px;
  margin-right: 5px;
}
</style>


